import { render, staticRenderFns } from "./ServiceProvider.vue?vue&type=template&id=8dd6c6ca&scoped=true&"
import script from "./ServiceProvider.vue?vue&type=script&lang=ts&"
export * from "./ServiceProvider.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceProvider.vue?vue&type=style&index=0&id=8dd6c6ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd6c6ca",
  null
  
)

export default component.exports